export default {
  theme: {
    blue: '青',
    teal: 'ティール',
    rose: 'ローズ',
    violet: 'バイオレット',
    orange: 'オレンジ',
  },
  home: {
    started: "始める",
    components: "コンポーネント",
    tableOfContent: "目次",
    version: "バージョン",
    changelog: "変更ログ",
    download: "ダウンロード",
  },
  toolbar: {
    plus: '追加',
    account: 'アカウント',
    logout: 'ログアウト',
    setting: '設定',
    theme: 'テーマ',
    language: '言語',
  },
  task: {
    task: 'タスク',
    listView: 'リスト表示',
    cardView: 'カード表示',
  },
  project: {
    listView: 'リスト表示',
    cardView: 'カード表示',
  },
  document: {
    listView: 'リスト表示',
    cardView: 'カード表示',
  },
  common: {
    save: '保存',
    cancel: 'キャンセル',
    confirm: '確認',
    delete: '削除',
    edit: '編集',
    more: 'もっと',
    message: 'メッセージ',
    notice: '通知',
    contact: '連絡',
    userLogin: 'ユーザーログイン',
    userLogout: 'ユーザーログアウト',
    previous: '前へ',
    next: '次へ',
    goToSlide: 'スライド {index} に移動',
    confirmDelete: 'このタスクを削除してもよろしいですか？',
    carouselImage: 'カルーセル画像 {index}',
    collapseCode: 'コードを折りたたむ',
    expandCode: 'コードを展開',
    copyCode: 'コードをコピー',
    totalTasks: '総タスク',
    hide: '非表示',
    show: '表示',
    completed: '完了',
    total: '合計',
    quantity: '数量',
    pleaseSelect: '選択してください',
    pleaseInput: '入力してください',
    selectUser: 'ユーザーを選択',
    back: '戻る',
  },
  date: {
    sunday: '日曜日',
    monday: '月曜日',
    tuesday: '火曜日',
    wednesday: '水曜日',
    thursday: '木曜日',
    friday: '金曜日',
    saturday: '土曜日',
    january: '1月',
    february: '2月',
    march: '3月',
    april: '4月',
    may: '5月',
    june: '6月',
    july: '7月',
    august: '8月',
    september: '9月',
    october: '10月',
    november: '11月',
    december: '12月',
    today: '今日',
    clear: 'クリア',
    now: '今',
  },
};

